<template>
    <div class="cover-konten">
        <div class="cover-sholat">
            <div id='get-loaction'>
                <img src="../assets/gambar/lokasi.png" alt='Lokasi'/>
                <h3 class="mt-3">Dimana lokasi anda sekarang ?</h3>

                <center>
                <div class="cover-input">
                    <input @keyup.enter="handleSubmit()" v-model="lokasi" type='text' id='lokasi' name='lokasi' placeholder=""/>
                    <button @click="handleSubmit()" class="btn-search" type='button'><i class='fa fa-search'></i></button>
                </div>
                </center>
            </div>
        </div>
        <!-- bagian waktu sholat -->
        <waktu-sholat v-bind:times='data[0]'></waktu-sholat>
    </div>
</template>
<style scoped>
/* waktu sholat */
/* akhir waktu sholat */
.cover-sholat 
{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
#get-loaction 
{
    width: 100%;
    height: auto;
    text-align: center;
}
#icon-lokasi 
{
    font-size: 60px;
    margin-bottom: 3%;
}
.cover-input 
{
    width: 40%;
    border-radius: 5px;
    padding: 0% 2% 0% 2%;
    box-shadow: 0px 10px 30px 2px rgba(0,0,0,0.1);
    margin-top: 5%;
    transition: 0.3s;
    border: 1px solid #ebebeb;
}
.cover-sholat input 
{
    width: 90%;
    height: 50px;
    border: none;
    outline: none;
}
.cover-input:hover{
    transform: scale(1.03);
    box-shadow: 0px 25px 30px 3px rgba(0,0,0,0.1);
}
.btn-search 
{
    border: none;
    color: gray;
    background-color: transparent;
}
.btn-search:focus{
    outline: none;
}

@media screen and (max-width: 780px)
{
    .cover-input
    {
        width: 90%;
    }
}

</style>
<script>
import Typed from 'typed.js';
import Waktu from './sholat/Waktu.vue';
import axios from 'axios';
import { bus } from '../main';

    export default{
        components: {
            'waktu-sholat': Waktu,
        },
        data(){
            return {
                lokasi: '',
                url: 'https://time.siswadi.com/pray/',
                proxy: 'https://cors-anywhere.herokuapp.com/',
                data: [],
            }
        },
        created(){
            document.title = "Jadwal Waktu Sholat";
        },
        mounted(){
            const options = {
                strings: ["Masukan lokasi anda ( contoh : Bandung )","Masukan lokasi anda ( contoh : Jakarta )","Masukan lokasi anda ( contoh : Surabaya )","Masukan lokasi anda ( contoh : Medan )"," Masukan lokasi anda ( contoh : Pontianak )","Masukan lokasi anda ( contoh : Bogor )","Masukan lokasi anda ( contoh : Palembang )","Masukan lokasi anda ( contoh : Makasar )","Masukan lokasi anda ( contoh : Papua )"],
                typeSpeed: 70,
                attr: 'placeholder',
                loop: true,
                smartBackspace: true,
            }
            new Typed('#lokasi', options);
            const lokasi = document.getElementById('lokasi');
            lokasi.focus();
        },
        methods: {
            popup(){
                const popup = document.querySelector('.waktu-sholat');
                popup.classList.toggle('show-waktu');
            },
            handleSubmit(){
                this.popup();
                axios.get(`${this.proxy}${this.url + this.lokasi}`)
                .then(res => {

                    const arr = []
                    arr[0] = {}
                    arr[0]['Subuh'] = res.data.data.Fajr;
                    arr[0]['Dzuhur'] = res.data.data.Dhuhr;
                    arr[0]['Ashar'] = res.data.data.Asr;
                    arr[0]['Maghrib'] = res.data.data.Maghrib;
                    arr[0]['Isa'] = res.data.data.Isha;
                    arr[0]['Metode'] = res.data.data.method;
                    arr[0]['Lokasi2'] = this.lokasi;
                    this.data = arr;
                }).then(() => {
                    bus.$emit('AddTimes', this.data[0]);
                    this.lokasi = '';
                })
                
            }
        }
    }
</script>